module.exports = __webpack_public_path__ + "img/6de5797.png";